<!--
 * @Autor: 高英娜
 * @Date: 2021-08-25 11:00:53
 * @LastEditTime: 2022-07-22 19:12:54
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/cockpit/index.vue
-->
<template>
<div class="common-web-home">
  <div class="common-web-home-bg"></div>
  <!-- <img src="@/assets/images/home-bg.png" style="width:100%;height:100%;" alt=""> -->
</div>
  <!-- <div class="home-wrap">
    <grid-layout
      :layout.sync="layout"
      :col-num="12"
      :row-height="60"
      :is-draggable="false"
      :is-resizable="false"
      :vertical-compact="true"
      :use-css-transforms="true"
    >
      <grid-item
        v-for="(item) in layout"
        :key="item.i"
        :static="item.static"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
      >
        <div class="config-grid-item">
          <component :is="item.componentName" ref="componentListEl"></component>
        </div> -->
        <!-- <div class="chart-wrapper" style="height:100%">
          <div class="tab_wrap" id="orderStatistic">
            <span class="tab_button bgColor" @click="buttonClick('orderStatistic', 'NEARLY', 'orderStatistic', $event)">近30天</span>
            <span class="tab_button" @click="buttonClick('orderStatistic', 'CURRENT_MONTH', 'orderStatistic', $event)">本月</span>
          </div>
          <order-statistic-analysis :buttonType="orderStatisticButtonType" height="calc(100% - 20px)"/>
        </div> -->
      <!-- </grid-item>
    </grid-layout>
  </div> -->
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout";
import cockpitApi from "@/api/cockpit/cockpit";
import OrderStatisticAnalysis from "./components/order-statistic-analysis";
import OrderTypeRate from "./components/order-type-rate";
import OrderCompleteRate from "./components/order-complete-rate";
import AverageFaultRepairTop10 from "./components/average-fault-repair-top10";
import OrderTodayStatistics from "./components/order-today-statistics";
import AlarmTodayStatistics from "./components/alarm-today-statistics";
import WarnStatisticAnalysis from "./components/warn-statistic-analysis";
import AverageFaultIntervalTop10 from "./components/average-fault-interval-top10";
import DeviceBranch from "./components/device-branch";
import DeviceWorkingAgeRate from "./components/device-workingAge-rate";
import AssetsTotal from "./components/assets-total";
import PartUsedNumberTop10 from "./components/part-used-number-top10";
import PartConsumeMoneyTop10 from "./components/part-consume-money-top10";
import DeviceOeeTop10 from "./components/device-oee-top10";
import MessageNotify from "./components/message-notify";
import Workbench from "./components/workbench";
import Role from "@/api/role/role";
export default {
  name: "Cockpit",
  components: {
    GridLayout,
    GridItem,
    OrderStatisticAnalysis,
    OrderTypeRate,
    OrderCompleteRate,
    AverageFaultRepairTop10,
    OrderTodayStatistics,
    AlarmTodayStatistics,
    WarnStatisticAnalysis,
    AverageFaultIntervalTop10,
    DeviceBranch,
    DeviceWorkingAgeRate,
    AssetsTotal,
    PartUsedNumberTop10,
    PartConsumeMoneyTop10,
    DeviceOeeTop10,
    MessageNotify,
    Workbench
  },
  data() {
    return {
      layout: [],
      leftList: []
    };
  },
  async created() {
    this.getHomeConfigData();
  },
  methods: {
    getHomeConfigData() {
      cockpitApi.getHomeConfig({}).then(res => {
        if (res.success && res.data && res.data.extendedData) {
          const coordinate = res.data.extendedData.coordinate || [];
          const items = coordinate.filter(() => true);
          this.layout = items || [];
        }
      });
    },
    gotoConfig() {
      this.$router.push({ path: "/config" });
    }
  }
};
</script>

<style lang="scss" scoped>
.common-web-home {
  width: 100%;
  height: 100%;
  .common-web-home-bg {
    width: 800px;
    height: 340px;
    position:absolute;
    top:50%;
    left: 50%;
    margin-top: -170px;
    margin-left: -400px;
    background:url(../../../assets/images/home-bg.png) no-repeat;
    background-size:100% 100%;
  }
 
}
.vue-grid-layout {
    background: #E5E5E5;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    background: #fff;
   // border: 1px solid black;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-grid-item .add {
    cursor: pointer;
}
.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}
::v-deep .vue-grid-item.vue-grid-placeholder{
    background: #00b259!important;
    height:3px!important;
}
  .config-grid-item{
    width:100%;
    height:100%;
    position: relative;
  }
.home-wrap{
  width:100%;
  height:100%;
  overflow-y: auto;
}
</style>

